import { useLayoutEffect } from 'react';

// Follow rendered geometry, including wrapped terms and keyboard offsets.
export const observeCookiebotFooterOffset = () => {
  const root = document.documentElement;
  let footers = [];
  let frame;
  const measure = () => {
    const offset = footers.reduce((maximum, footer) => {
      const style = getComputedStyle(footer);
      const rect = footer.getBoundingClientRect();
      if (style.display === 'none' || style.visibility === 'hidden' ||
          rect.height === 0 || rect.bottom <= 0 || rect.top >= window.innerHeight) return maximum;
      return Math.max(maximum, window.innerHeight - rect.top);
    }, 0);
    const value = `${Math.ceil(offset)}px`;
    if (root.style.getPropertyValue('--CookiebotFooterOffset') !== value) {
      root.style.setProperty('--CookiebotFooterOffset', value);
    }
  };
  const scheduleMeasure = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(measure);
  };
  const resizeObserver = new ResizeObserver(scheduleMeasure);
  const refreshFooters = () => {
    const next = Array.from(document.querySelectorAll('[data-snackbar-footer="true"]'));
    if (next.length !== footers.length || next.some((footer, index) => footer !== footers[index])) {
      resizeObserver.disconnect();
      footers = next;
      footers.forEach(footer => resizeObserver.observe(footer));
    }
    scheduleMeasure();
  };
  const mutationObserver = new MutationObserver(refreshFooters);
  mutationObserver.observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-snackbar-footer', 'class', 'style', 'hidden'],
  });
  refreshFooters();
  window.addEventListener('resize', scheduleMeasure);
  window.addEventListener('scroll', scheduleMeasure, true);
  document.addEventListener('transitionend', scheduleMeasure);
  window.visualViewport?.addEventListener('resize', scheduleMeasure);
  window.visualViewport?.addEventListener('scroll', scheduleMeasure);
  return () => {
    cancelAnimationFrame(frame);
    resizeObserver.disconnect();
    mutationObserver.disconnect();
    window.removeEventListener('resize', scheduleMeasure);
    window.removeEventListener('scroll', scheduleMeasure, true);
    document.removeEventListener('transitionend', scheduleMeasure);
    window.visualViewport?.removeEventListener('resize', scheduleMeasure);
    window.visualViewport?.removeEventListener('scroll', scheduleMeasure);
    root.style.removeProperty('--CookiebotFooterOffset');
  };
};

export const useCookiebotFooterOffset = () => {
  useLayoutEffect(observeCookiebotFooterOffset, []);
};
